<div
  class="upload-buttons flex flex-row flex-wrap justify-center gap-2 xl:gap-5"
  [ngStyle]="{ 'z-index': !dragOver ? '99' : '-1' }"
  [ngClass]="{ 'flex-col': fromBar, 'xl:flex-row': fromBar }"
>
  <input
    class="absolute"
    type="file"
    #fileDropRef
    id="fileDropRef"
    accept=".pdf"
    multiple
    (change)="fileBrowseHandler($event.target['files'])"
  />
  <ion-button
    class="upload-files-button barlow"
    expand="block"
    color="primary"
    for="fileDropRef"
    (click)="fileDropRef.click()"
  >
    <ion-icon icon="assets/icon/upload-doc.svg"></ion-icon>
    <span>Subir documentos</span>
  </ion-button>
  <ion-button class="drive-button" expand="block" color="light" (click)="openGoogleDrivePicker()">
    <ion-icon icon="assets/icon/drive.svg"></ion-icon>
  </ion-button>
  <ion-button
    class="dropbox-button"
    *ngIf="isDropboxSupported()"
    expand="block"
    color="light"
    (click)="openDropboxPicker()"
  >
    <ion-icon icon="assets/icon/dropbox.svg"></ion-icon>
  </ion-button>
</div>
<ngx-file-drop
  *ngIf="isDesktop() && !files.length"
  dropZoneLabel="Drop files here"
  [class.dragging]="dragging"
  (onFileDrop)="dropped($event)"
  (onFileOver)="fileOver($event)"
  (onFileLeave)="fileLeave($event)"
  dropZoneClassName="dropFileZone"
  contentClassName="dropFileContent"
>
  <ng-template ngx-file-drop-content-tmp> También puedes arrastrar tus archivos o carpetas aquí. </ng-template>
</ngx-file-drop>
<span *ngIf="isDesktop() && !files.length" class="drag-files-caption"
  >También puedes arrastrar tus archivos o carpetas aquí.</span
>
<div *ngIf="isDesktop() && !files.length" class="dragging-notification" [class.visible]="dragOver">
  <ng-lottie *ngIf="dragOver" [options]="draggingFilesAnimationOptions"></ng-lottie>
  <div>Suelta los archivos para subirlos a Copyfly</div>
</div>
